import { gql } from 'apollo-angular';

export const feedbackEligibleQuery = gql`
  query feedbackEligible {
    feedbackEligible
  }
`;

export const saveFeedbackMutation = gql`
  mutation saveFeedback($input: ResidentFeedbackInputBean!) {
    saveFeedback(input: $input)
  }
`;
